module.exports = __webpack_public_path__ + "img/img4.d2b18baa.png";